<div class="bg-light flex-row align-items-center edit-content">
  <c-container>
    <!-- Temple / festival / page details: saved on their own, never touch the owner's account -->
    <h3 class="mt-3">{{ itemLabel }} Details</h3>
    <c-row class="mt-2">
      <c-col md="6">
        <label>{{ itemLabel }} Name *</label>
        <input cFormControl name="communityName" [(ngModel)]="communityDetails.CommunityName" type="text" />
      </c-col>
      <c-col md="6" *ngIf="isTemple">
        <label>Deity &amp; tradition</label>
        <input cFormControl name="communityTag" [(ngModel)]="communityDetails.CommunityTag" type="text" />
      </c-col>
      <c-col md="12" class="mt-2">
        <label>Description</label>
        <textarea
          cFormControl
          name="communityDescription"
          rows="3"
          maxlength="255"
          [(ngModel)]="communityDetails.CommunityDescription"
        ></textarea>
      </c-col>
    </c-row>

    <c-row class="mt-2" *ngIf="isTemple">
      <c-col md="6">
        <label>Address</label>
        <input cFormControl name="address" [(ngModel)]="communityDetails.Address" type="text" maxlength="255" />
      </c-col>
      <c-col md="6">
        <label>City / town</label>
        <input cFormControl name="city" [(ngModel)]="communityDetails.City" type="text" maxlength="45" />
      </c-col>
      <c-col md="6" class="mt-2">
        <label>District</label>
        <input cFormControl name="county" [(ngModel)]="communityDetails.County" type="text" maxlength="250" />
      </c-col>
      <c-col md="6" class="mt-2">
        <label>State / region</label>
        <input cFormControl name="templeState" [(ngModel)]="communityDetails.State" type="text" maxlength="45" />
      </c-col>
      <c-col md="4" class="mt-2">
        <label>Pincode</label>
        <input cFormControl name="templeZip" [(ngModel)]="communityDetails.Zip" type="text" maxlength="45" />
      </c-col>
      <c-col md="4" class="mt-2">
        <label>Phone</label>
        <input cFormControl name="templePhone" [(ngModel)]="communityDetails.Phone" type="text" maxlength="50" />
      </c-col>
      <c-col md="4" class="mt-2">
        <label>Website</label>
        <input cFormControl name="templeWebsite" [(ngModel)]="communityDetails.Website" type="text" maxlength="500" />
      </c-col>
    </c-row>

    <c-row class="mt-3">
      <c-col md="4" class="d-grid gap-2">
        <label>Profile image (logo)</label>
        <img
          class="image-preview logo-preview"
          [src]="logoPreview || communityDetails.logoImg || '/assets/img/avatars/placeholder-user.png'"
          onerror="this.onerror=null;this.src='/assets/img/avatars/placeholder-user.png';"
          alt="Logo"
        />
        <div class="d-flex gap-2">
          <button cButton color="secondary" variant="outline" size="sm" type="button" (click)="logoInput.click()">
            Change logo
          </button>
          <button
            cButton
            color="danger"
            variant="outline"
            size="sm"
            type="button"
            *ngIf="logoPreview || communityDetails.logoImg"
            (click)="removeImage('logo')"
          >
            Remove
          </button>
        </div>
        <input #logoInput type="file" accept="image/*" hidden (change)="onImageSelected($event, 'logo')" />
      </c-col>
      <c-col md="8" class="d-grid gap-2">
        <label>Cover image</label>
        <img
          class="image-preview cover-preview"
          [src]="coverPreview || communityDetails.coverImg || '/assets/img/avatars/placeholder-room.png'"
          onerror="this.onerror=null;this.src='/assets/img/avatars/placeholder-room.png';"
          alt="Cover"
        />
        <div class="d-flex gap-2">
          <button cButton color="secondary" variant="outline" size="sm" type="button" (click)="coverInput.click()">
            Change cover
          </button>
          <button
            cButton
            color="danger"
            variant="outline"
            size="sm"
            type="button"
            *ngIf="coverPreview || communityDetails.coverImg"
            (click)="removeImage('cover')"
          >
            Remove
          </button>
        </div>
        <input #coverInput type="file" accept="image/*" hidden (change)="onImageSelected($event, 'cover')" />
      </c-col>
    </c-row>

    <div class="d-flex justify-content-end mt-3">
      <button cButton color="primary" type="button" [disabled]="isSavingDetails" (click)="saveDetails()">
        {{ isSavingDetails ? "Saving..." : "Save " + (itemLabel | lowercase) + " details" }}
      </button>
    </div>

    <hr class="my-4" />
    <!-- <c-row class="justify-content-center mt-2">
        <c-col md="6">
          <label>Is Approve</label>
          <input
            cFormControl
            name="uname"
            [(ngModel)]="communityDetails.isApprove"
            type="text"
          />
        </c-col>
        <c-col md="6">
          <label>Zip</label>
          <input
            cFormControl
            name="uname"
            [(ngModel)]="memberDetails.Zip"
            type="text"
            disabled
          />
        </c-col>
      </c-row> -->
    <h3>Owner Account</h3>
    <p class="text-medium-emphasis small">This edits the owner's own user profile, not the {{ itemLabel | lowercase }}.</p>
    <form
      [formGroup]="userForm"
      (ngSubmit)="saveChanges()"
      (change)="onChangeData()"
    >
      <c-row class="justify-content-center mt-2">
        <c-col md="6">
          <label>First Name</label>
          <input
            cFormControl
            name="FirstName"
            formControlName="FirstName"
            type="text"
          />
        </c-col>
        <c-col md="6">
          <label>Last Name</label>
          <input
            cFormControl
            formControlName="LastName"
            name="LastName"
            type="text"
          />
        </c-col>
      </c-row>
      <c-row class="justify-content-center mt-2">
        <c-col md="12">
          <label>Username</label>
          <input
            cFormControl
            name="uname"
            type="text"
            formControlName="Username"
          />
        </c-col>
      </c-row>
      <c-row class="justify-content-center mt-2">
        <c-col md="6">
          <label>Email</label>
          <input
            cFormControl
            name="email"
            type="email"
            [(ngModel)]="memberDetails.Email"
            [ngModelOptions]="{ standalone: true }"
            disabled
          />
          <!-- <div
            class="srv-validation-message text-danger"
            *ngIf="userForm.controls['Email'].invalid &&
                  userForm.controls['Email'].errors?.['required']"
          >
            Email field is required.
          </div> -->
        </c-col>
        <c-col md="6">
          <label>Notification Email</label>
          <input
            cFormControl
            name="notificatonEmail"
            type="email"
            [(ngModel)]="communityDetails.notificationEmail"
            [ngModelOptions]="{ standalone: true }"
            
          />
        </c-col>
      </c-row>
      <c-row class="justify-content-center mt-2">
        <c-col md="6">
          <label>Phone</label>
          <input
            cFormControl
            name="mobileNo"
            formControlName="MobileNo"
            type="text"
          />
        </c-col>
        <c-col md="6" class="d-grid">
          <label>Country</label>
          <select
            id="Country"
            required
            name="Country"
            class="form-control w-100"
            cFormControl
            [(ngModel)]="memberDetails.Country"
            [ngModelOptions]="{ standalone: true }"
            (change)="changeCountry($event)"
          >
            <option
              [value]="item.country_code"
              *ngFor="let item of allCountryData"
            >
              {{ item.country }}
            </option>
          </select>
        </c-col>
      </c-row>
      <c-row class="justify-content-center mt-2">
        <c-col md="6">
          <label>Zip</label>
          <input
            cFormControl
            name="zip"
            formControlName="Zip"
            type="text"
            #zipCode
          />
          <div
            class="srv-validation-message text-danger"
            *ngIf="userForm.controls['Zip'].touched &&
            userForm.controls['Zip'].errors?.['required']"
          >
            Zip field is required.
          </div>
        </c-col>
        <c-col md="6" class="d-grid">
          <label>State</label>
          <input
            cFormControl
            name="state"
            formControlName="State"
            type="text"
          />
        </c-col>
      </c-row>
      <c-row class="justify-content-center mt-2">
        <c-col md="12">
          <label for="">Make Community Admin</label>
          <ng-select
            [items]="userList"
            bindLabel="Username"
            bindValue="Id"
            [multiple]="true"
            placeholder="Select user"
            (search)="onItemSelect($event)"
          >
            <ng-template ng-option-tmp let-item="item" let-index="index">
              <div
                *ngIf="!memberIds.includes(item.Id)"
                (click)="onSelectUser(item)"
              >
                <img
                  height="20"
                  width="20"
                  [src]="item.ProfilePicName"
                  class="me-1"
                  onerror="this.onerror=null;this.src='/assets/img/avatars/placeholder-user.png';"
                />
                <span>{{ item.Username }}</span>
              </div>
            </ng-template>
          </ng-select>
        </c-col>
      </c-row>
      <c-row class="float-end mt-3">
        <button cButton color="primary" type="submit">
          {{ isEdit ? "Save changes" : "Edit" }}
        </button>
      </c-row>

      <c-row class="justify-content-center mt-4">
        <c-col md="12">
          <label for="">Members</label>
          <div class="d-flex flex-wrap">
            <div
              class="single-box d-flex align-items-center gap-2 px-3 py-2 w-100"
              *ngFor="let member of adminList"
            >
              <img
                class="w-40-px h-40-px rounded-4"
                loading="lazy"
                data-src="{{
                  member?.ProfilePicName ||
                    '/assets/images/avtar/default-profile.jpg'
                }}"
                height="40"
                width="40"
                onerror="this.onerror=null;this.src='/assets/images/avtar/default-profile.jpg'"
                alt="avatar"
              />
              <div
                class="d-flex flex-column justify-content-center align-items-start w-100"
              >
                <p class="mb-1">{{ member?.Username }}</p>
                <span class="font-12-px description">{{
                  member?.isAdmin === "Y" ? "Admin" : "Member"
                }}</span>
              </div>
              <ng-container
                *ngIf="communityDetails.profileId !== member.profileId"
              >
                <span
                  class="material-symbols-outlined"
                  (click)="removeasAdmin(member.profileId)"
                >
                  cancel
                </span>
              </ng-container>
            </div>
          </div>
        </c-col>
      </c-row>
    </form>
  </c-container>
</div>
